module.exports = __webpack_public_path__ + "assets/img/a6b6fa429778bd01b00adb917a24c893.png";